import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "serviceprovider",
  "use": "serviceprovider-usage",
  "viewBox": "0 0 19.43 20.77",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 19.43 20.77\" id=\"serviceprovider\"><title>联合 5</title><g data-name=\"图层 2\"><g data-name=\"图层 1\"><path data-name=\"联合 5\" d=\"M0 20.05a9.72 9.72 0 0 1 6.58-9.24A5.86 5.86 0 1 1 14.66 9a5.72 5.72 0 0 1-1.81 1.82A9.73 9.73 0 0 1 19.43 20 .72.72 0 0 1 18 20a8.3 8.3 0 0 0-7.69-8.3l3.09 5.67-3.54 2.97-3.53-2.92 3.09-5.69a8.31 8.31 0 0 0-8 8.32.73.73 0 0 1-.71.72.72.72 0 0 1-.71-.72zM5.28 5.83A4.43 4.43 0 1 0 9.7 1.39a4.42 4.42 0 0 0-4.42 4.44z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/serviceprovider.svg
// module id = mCAt
// module chunks = 6